import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigService } from '@/providers/services/app/app-config';
import { SubjectModel } from '@/models/groups/subjects';
import { authAPI } from '@/providers/apis/auth/auth';
import { isAPICatchError } from '@/utils/utils';

@Component({
    name: 'class-level',
    components: {
        'g-icon': GoogleMaterialIcon,
    },
})

export default class ClassLevel extends Vue {

    // ---------------------------------------------------------------
    // Properties

    @Prop()
    private classData!: any;

    @Prop()
    private activeSubject!: SubjectModel;

    @Prop()
    private activeYear!: string;

    @Prop()
    private activeMonth!: string;

    private get session() {
        return sessionService.getSession();
    }

    private get getAccessToken() {
        return this.session ? this.session.access_token : '';
    }

    private namespace: any = appConfigService.getProductUrl();

    private accessToken: string = this.getAccessToken;

    private currentClass: string = '';

    private endPointUrl: string = '';




    // --------------------------------------------------------------
    // Hooks
    private created() {
        this.currentClass = this.classData.id;
        authAPI.setImpersonateToken(this.accessToken).then((data: any) => {
            if (!isAPICatchError(data)) {
                this.endPointUrl = `${this.namespace}/?am=st&redirect_url=${this.namespace}/teacher/class/${this.currentClass}/class-activities`;
            }
        });
    }
    // ----------------------------------------------------------------
    // Actions

    private onClose() {
        this.$emit('onClose');
    }

}
